<template>
    <div class="row pl-2">
      <div class="col-3 d-flex flex-row bg-primary align-items-center" style="padding:0">
        <div class="d-flex flex-row bg-red-600 align-items-center logo2 col-12" >
          <a class="navbar-brand" href="/">
            <img src="@/assets/asw-logo.png" class="image-shadow" alt="logo" style="width: 90px;">
          </a>
          <div>
            <a class="nav-link white" href="/"> Home <span class="sr-only">(current)</span></a>
          </div>
          <div>
            <a class="nav-link white" href="/recom">SO Approval</a>
          </div>
          <div>
            <a class="nav-link white" href="/transit">Transit</a>
          </div>
        </div>
      </div>
      <div class="col-9 bg-red-600" style="padding:0">
        <div class="bg-primary mr-auto d-flex justify-content-end logo1 col-12 align-items-center">
          <button class="btn btn-primary btn-sm rounded-circle" @click="changePassword">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          </button>
          <button class="btn btn-danger rounded-circle" @click="logout">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
          </button>
        </div>
      </div>

    </div>

</template>
<script lang="ts" src="./Header.ts" />
<!--     <nav class="navbar navbar-expand-lg navbar-light bg-blue-200 row">-->
<!--       <div class="row">-->
<!--         <div class="col-4">-->
<!--           One of three columns-->
<!--         </div>-->
<!--         <div class="col-4">-->
<!--           One of three columns-->
<!--         </div>-->
<!--         <div class="col-4">-->
<!--           One of three columns-->
<!--         </div>-->
<!--       </div>-->
<!--            <div class="d-flex flex-row">-->
<!--              <div class="col-6">-->
<!--                <a class="navbar-brand" href="/">-->
<!--                  <img src="@/assets/asw-logo.png" alt="logo" style="width: 90px;">-->
<!--                </a>-->
<!--&lt;!&ndash;                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">&ndash;&gt;-->
<!--&lt;!&ndash;                  <span class="navbar-toggler-icon"></span>&ndash;&gt;-->
<!--&lt;!&ndash;                </button>&ndash;&gt;-->
<!--                <ul class="navbar-nav mr-auto">-->
<!--                  <li :class="`nav-item ${$route.path=== '/'? 'active': ''}`">-->
<!--                    <a class="nav-link" href="/"> Home <span class="sr-only">(current)</span></a>-->
<!--                  </li>-->
<!--                  <li :class="`nav-item ${$route.path=== '/recom'? 'active': ''}`" >-->
<!--                    <a class="nav-link" href="/recom">SO Approval</a>-->
<!--                  </li>-->
<!--                  <li :class="`nav-item ${$route.path=== '/transit'? 'active': ''}`">-->
<!--                    <a class="nav-link" href="/transit">Transit</a>-->
<!--                  </li>-->
<!--                </ul>-->

<!--              </div>-->
<!--              <div class="col-6">-->
<!--                <div class="collapse navbar-collapse" id="navbarSupportedContent">-->
<!--                  <form class="form-inline my-2 my-lg-0">-->
<!--                    <button class="btn btn-primary btn-sm rounded-circle" @click="changePassword">-->
<!--                      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">-->
<!--                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />-->
<!--                      </svg>-->
<!--                    </button>-->
<!--                    <button class="btn btn-danger rounded-circle" @click="logout">-->
<!--                      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">-->
<!--                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />-->
<!--                      </svg>-->
<!--                    </button>-->
<!--                  </form>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->




<!--     </nav>-->